import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300 py-12 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <h2 className="text-2xl font-extrabold text-white mb-4">Primium<span className="text-indigo-500">Flats</span></h2>
          <p className="text-slate-400 text-sm leading-relaxed">
            India's premier destination for luxury properties, modern apartments, and verified real estate listings.
          </p>
        </div>
        <div>
          <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Quick Links</h3>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/" className="hover:text-white transition">Home</Link></li>
            <li><Link to="/about" className="hover:text-white transition">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-white transition">Contact Us</Link></li>
            <li><Link to="/add-property" className="hover:text-white transition">Post Property</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Property Types</h3>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><span className="hover:text-white transition cursor-pointer">Luxury Villas</span></li>
            <li><span className="hover:text-white transition cursor-pointer">3 BHK Apartments</span></li>
            <li><span className="hover:text-white transition cursor-pointer">Penthouses</span></li>
            <li><span className="hover:text-white transition cursor-pointer">Commercial Spaces</span></li>
          </ul>
        </div>
        <div>
          <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contact Info</h3>
          <p className="text-sm text-slate-400 mb-2">DLF Phase 5, Gurugram, Haryana</p>
          <p className="text-sm text-slate-400 mb-2">Email: support@primiumflats.com</p>
          <p className="text-sm text-slate-400">Phone: +91 98765 43210</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 border-t border-slate-900 mt-10 pt-6 text-center text-xs text-slate-500">
        &copy; {new Date().getFullYear()} PrimiumFlats India. All rights reserved.
      </div>
    </footer>
  );
}